export const getSellerAgreementAttachmentOffsets = {
  pageNumber: 9,
  offsetLeft: 96,
  offsetTop: 390,
};
